import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./StyleCount.css";
import { useLocale } from "../LocaleProvider";

const StyleCount = ({ itemCount, className }) => {
  const { formatTranslation, formatNumber } = useLocale();

  return (
    <p className={classNames(styles.styleCount, className)}>
      {formatTranslation("plp_web_style_count_noun", {
        smart_count: itemCount,
        formattedCount: formatNumber(itemCount),
      })}
    </p>
  );
};

StyleCount.propTypes = {
  itemCount: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default StyleCount;
